import { StylesConfig } from 'react-select'

type OptionType = {
    label: string
    value: string
}

const primaryColor = '#008541'
const errorColor = '#f87171'
const defaultBorder = '#e5e7eb'
const inputBg = '#FBFBFB'

export const selectStyles = (hasError: boolean): StylesConfig<OptionType, true> => ({
    control: (base, state) => ({
        ...base,
        minHeight: '55px',
        borderRadius: '7px',
        borderWidth: '1.5px',
        backgroundColor: inputBg,
        borderColor: hasError
            ? errorColor
            : state.isFocused
                ? primaryColor
                : defaultBorder,
        boxShadow: 'none',
        '&:hover': {
            borderColor: hasError ? errorColor : "",
        },
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: primaryColor + '20',
    }),
    multiValueLabel: (base) => ({
        ...base,
        color: primaryColor,
    }),
    multiValueRemove: (base) => ({
        ...base,
        color: primaryColor,
        ':hover': {
            backgroundColor: primaryColor,
            color: 'white',
        },
    }),
})
